const portfolio = [
  {
    id: 1,
    img: "/assets/img/project/project_1_1.jpg",
    title: "IT Consultency",
    category: "Technology",
  },
  {
    id: 2,
    img: "/assets/img/project/project_1_2.jpg",
    title: "Web Development",
    category: "Technology",
  },
  {
    id: 3,
    img: "/assets/img/project/project_1_3.jpg",
    title: "Website Design",
    category: "Technology",
  },
  {
    id: 4,
    img: "/assets/img/project/project_1_4.jpg",
    title: "SEO Optimization",
    category: "Marketing",
  },
  {
    id: 5,
    img: "/assets/img/project/project_1_5.jpg",
    title: "Digital Marketing",
    category: "Marketing",
  },
  {
    id: 6,
    img: "/assets/img/project/project_1_6.jpg",
    title: "Business Analysis",
    category: "Business",
  },
  {
    id: 7,
    img: "/assets/img/project/project_1_7.jpg",
    title: "Software Service",
    category: "Technology",
  },
  {
    id: 8,
    img: "/assets/img/project/project_1_8.jpg",
    title: "Data Recovery",
    category: "Technology",
  },
  {
    id: 9,
    img: "/assets/img/project/project_1_9.jpg",
    title: "Cloud Computing",
    category: "Technology",
  },
];

export default portfolio;
